import { SagaIterator } from '@redux-saga/core';
import { takeEvery } from 'redux-saga/effects';
import { workerUpdateDspSaga } from './workers';
import { fetchUploadDsp } from '../reducer';

export default function* watchSideMenu(): SagaIterator {
  yield takeEvery(fetchUploadDsp, workerUpdateDspSaga);
}
